import { useEffect, useRef } from "react";
import {
  GroupedArticleByLevel,
  OrderItem,
  SelectedArticle,
} from "../../../../interfaces/Catalogue";
import LevelItem from "../LevelItem/LevelItem";

interface LevelsListProps {
  levels: GroupedArticleByLevel[];
  onOrderGenerated: (selectedArticles: OrderItem) => void;
  scrollToLevel: any;
  incompleteLevel: number;
}

const LevelList: React.FC<LevelsListProps> = ({
  levels,
  onOrderGenerated,
  scrollToLevel,
  incompleteLevel,
}) => {
  const levelRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    scrollToLevel.current = (id: string) => {
      const element = levelRefs.current[id];
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 0);
      }
    };
  }, [scrollToLevel]);

  const handleOrderGenerated = (
    level: GroupedArticleByLevel,
    selectedArticles: SelectedArticle[]
  ) => {
    onOrderGenerated({ level, selectedArticles: selectedArticles });
  };

  return (
    <div>
      {levels?.map((level, index) => (
        <div key={level.id} ref={(el) => (levelRefs.current[level.id] = el)}>
          <LevelItem
            key={level.id}
            level={level}
            handleOrderGenerated={handleOrderGenerated}
            isIncompleted={level.id == incompleteLevel}
            levelIndex={index}
          />
        </div>
      ))}
    </div>
  );
};

export default LevelList;
